import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen flex flex-col bg-gradient-to-b from-white to-gray-50" data-id="element-0">
      <Header data-id="element-1" />
      <HeroSection data-id="element-2" />
      <Footer data-id="element-3" />
    </div>;
}